import axios from 'axios';

const API_URL = 'https://decohomesinrival.com.ar/ecommerce-api/public/api';
//const API_URL = 'http://localhost/ecommerce-api/public/api';
// Configurar interceptores para axios
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Solo redirigir al login si es un endpoint protegido y no tiene token
    if (error.response?.status === 401 && localStorage.getItem('auth_token')) {
      localStorage.removeItem('auth_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Servicios de productos (públicos - no requieren autenticación)
export const productService = {
  getAll: (params = {}) => api.get('/products', { params }),
  getById: (id) => api.get(`/products/${id}`),
  search: (query) => api.get(`/products?search=${encodeURIComponent(query)}`),
  getByCategory: (categoryId, params = {}) =>
    api.get(`/products?category=${categoryId}`, { params }),
};

// Servicios de categorías
export const categoryService = {
  getAll: () => api.get('/categories'),
  getById: (id) => api.get(`/categories/${id}`),
};

// Servicios de autenticación
export const authService = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    return Promise.resolve();
  },
  getProfile: () => api.get('/auth/me'),
  updateProfile: (userData) => api.put('/auth/profile', userData),
  changePassword: (passwords) => api.put('/auth/change-password', passwords),
};

// Servicios de carrito
export const cartService = {
  get: () => api.get('/cart'),
  add: (productId, quantity = 1) => api.post('/cart', { product_id: productId, quantity }),
  updateItem: (itemId, quantity) => api.put(`/cart/items/${itemId}`, { quantity }),
  removeItem: (itemId) => api.delete(`/cart/items/${itemId}`),
  clear: () => api.delete('/cart'),
};

// Servicios de órdenes (cliente)
export const orderService = {
  getMyOrders: (params = {}) => api.get('/orders', { params }),
  getById: (id) => api.get(`/orders/${id}`),
  cancel: (id) => api.post(`/orders/${id}/cancel`),
};

// Servicios de checkout
export const checkoutService = {
  validate: (checkoutData) => api.post('/checkout/validate', checkoutData),
  calculate: (couponCode = null) => api.post('/checkout/calculate', { coupon_code: couponCode }),
  createOrder: (checkoutData) => api.post('/checkout/create-order', checkoutData), // Crear orden directamente
  createMercadoPagoPreference: (checkoutData) =>
    api.post('/checkout/mercadopago/create-preference', checkoutData),
};

// Servicios de reservas (público - no requiere autenticación)
export const reservationService = {
  create: (reservationData) => api.post('/reservations', reservationData),
};

// Servicios de pagos
export const paymentService = {
  getMyPayments: () => api.get('/payments'),
  getByOrder: (orderId) => api.get(`/payments/${orderId}`),
  getDetail: (paymentId) => api.get(`/payments/detail/${paymentId}`),
};

// Servicios de direcciones
export const addressService = {
  getAll: () => api.get('/addresses'),
  create: (addressData) => api.post('/addresses', addressData),
  update: (id, addressData) => api.put(`/addresses/${id}`, addressData),
  delete: (id) => api.delete(`/addresses/${id}`),
  setDefault: (id) => api.put(`/addresses/${id}/default`),
};

// Servicios de cupones
export const couponService = {
  validate: (code, subtotal) => api.post('/coupons/validate', { code, subtotal }),
};

// Servicios de wishlist
export const wishlistService = {
  get: () => api.get('/wishlist'),
  add: (productId) => api.post('/wishlist', { product_id: productId }),
  remove: (productId) => api.delete(`/wishlist/${productId}`),
};

// Servicio para verificar el estado de la API
export const healthService = {
  check: () => api.get('/'),
};

export default api;
